import { render, staticRenderFns } from "./ObjectWithPopover.vue?vue&type=template&id=0c5050b2&"
import script from "./ObjectWithPopover.vue?vue&type=script&lang=ts&"
export * from "./ObjectWithPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports